<template>
    <div class="gif-player-container">
        <video
            ref="videoElement"
            class="gif-player"
            :src="src"
            :autoplay="autoplay"
            :loop="loop"
            :muted="muted"
            :controls="controls"
            :poster="poster"
            @click="togglePlay"
        ></video>
        
        <div class="gif-label">
            <span>{{ $t("message.mediaBadgeGif") }}</span>
        </div>
        
        <div class="fullscreen-button" @click.stop="openFullscreen">
            <span class="material-icons">open_in_new</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "GifPlayer",
    props: {
        src: {
            type: String,
            required: true
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        loop: {
            type: Boolean,
            default: true
        },
        muted: {
            type: Boolean,
            default: true
        },
        controls: {
            type: Boolean,
            default: false
        },
        poster: {
            type: String,
            default: ""
        }
    },
    methods: {
        togglePlay() {
            const video = this.$refs.videoElement;
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
        },
        openFullscreen() {
            window.open(this.src, '_blank');
        }
    }
};
</script>

<style scoped lang="scss">
.gif-player-container {
    position: relative;
    width: 100%;
    overflow: hidden;
    cursor: pointer;

    .gif-player {
        width: 100%;
        display: block;
    }
    
    .gif-label {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: rgba(0, 0, 0, 0.5);
        width: 70px;
        height: 70px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        
        span {
            color: white;
            font-size: 20px;
            font-weight: bold;
            text-align: center;
        }
    }
    
    .fullscreen-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background-color: rgba(0, 0, 0, 0.5);
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        
        .material-icons {
            color: white;
            font-size: 16px;
        }
    }
}
</style> 